export default __webpack_public_path__ + "static/media/not-found.ace27eb3.png";